import { Skeleton } from "@/shared/ui";

export default function TaxFormSkeleton() {
  return (
    <div className="radius-3xl surface-base-fill p-7">
      <div className="flex items-center gap-4 mb-6">
        <Skeleton height={40} width={40} borderRadius={8} />
        <Skeleton height={20} width={320} />
      </div>

      <div className="flex items-center gap-2 mb-6">
        {Array.from({ length: 4 }).map((_, i) => (
          <Skeleton key={i} height={36} width={100} borderRadius={8} />
        ))}
      </div>

      <Skeleton height={40} borderRadius={8} className="mb-5" />

      <div className="flex flex-col gap-2 mb-5">
        <Skeleton height={18} width={280} />
        <Skeleton height={14} width={200} />
      </div>

      <div className="surface-base-fill radius-lg overflow-hidden">
        <div className="p-3 surface-component-fill">
          <div className="grid grid-cols-[120px_1fr_120px] gap-4">
            <Skeleton height={14} width={80} />
            <Skeleton height={14} width={120} />
            <Skeleton height={14} width={60} className="ml-auto" />
          </div>
        </div>
        {Array.from({ length: 12 }).map((_, i) => (
          <div key={i} className="p-3">
            <div className="grid grid-cols-[120px_1fr_120px] gap-4 items-center">
              <Skeleton height={14} width={90} />
              <Skeleton height={14} width={i % 3 === 0 ? 300 : 220} />
              <Skeleton height={14} width={70} className="ml-auto" />
            </div>
          </div>
        ))}
      </div>

      <div className="flex items-center justify-between p-4 surface-component-fill radius-lg mt-6">
        <Skeleton height={18} width={200} />
        <Skeleton height={22} width={120} />
      </div>
    </div>
  );
}
